import React, { useState, useEffect } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, useLocation } from 'react-router-dom';
import ApiService from '../../services/apiService';
import { toast } from 'react-toastify';
import BranchGrid from './grid';
import Select from "react-select";
import { RiRefreshLine } from "react-icons/ri";
import { FaSave } from "react-icons/fa";
import { hasPermission } from "../../services/roleService"
import Pagination from '../pagination/pagination';
import { GrEdit } from "react-icons/gr";
const BranchMaster = () => {
    let navigate = useNavigate();
    const location = useLocation();
    const [defaultSelection, setDefault] = useState(false);
    const [companies, setCompanies] = useState([]);
    const [permissions, setPermissions] = useState([]);
    const [pageSize, setPageSize] = useState(20);
    const [pagination, setPagination] = useState();
    const [rowData, setRowData] = useState([]);
    const [selectedRow, setSelectedRow] = useState(null);

    const [formData, setFormData] = useState({
        BranchCode: "",
        BranchName: "",
        Company: []
    });

    useEffect(() => {
        fetchBranchData();
        const storedPermissions = JSON.parse(localStorage.getItem('RoleAccess')) || [];
        setPermissions(storedPermissions);
        if (pageSize) {
            fetchBranchData();
        }
    }, [pageSize]);

    const checkPermission = (moduleName, action) => {
        return hasPermission(moduleName, action, permissions);
    };
    // const canEditMaster = checkPermission('Branch Master', 'edit');
    // const canCreateMaster = checkPermission('Branch Master', 'create');
    const canEditMaster = true;
    const canCreateMaster = true;
    const handleEdit = (clickedRowData) => {

        if (clickedRowData?.record_Id) {
            const selectedCompany = companies?.find(comp => comp?.companyId === clickedRowData?.companyId);
            setFormData({
                recordId: clickedRowData?.record_Id,
                BranchName: clickedRowData?.branchName || "",
                BranchCode: clickedRowData?.branchCode || "",
                Company: { label: selectedCompany?.companyName, value: selectedCompany },
            });
        } else if (selectedRow) {
            const selectedCompany = companies?.find(comp => comp?.companyId === selectedRow?.companyId);
            setFormData({
                recordId: selectedRow?.record_Id,
                BranchName: selectedRow?.branchName || "",
                BranchCode: selectedRow?.branchCode || "",
                Company: { label: selectedCompany?.companyName, value: selectedCompany },
            });
        }
    };
    const handleInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    const handleCompanyChange = (selectedOption) => {
        setFormData({ ...formData, Company: selectedOption });
    };
    const fetchBranchData = async (newPageNo = pagination?.currentPage) => {
        try {
            const apiService = new ApiService()
            const CompanyRes = await apiService.get('GET_COMPANY');
            const params = new URLSearchParams();
            params.append('PageNo', newPageNo || 1);
            params.append('PageSize', pageSize || 20);
            const response = await apiService.getApiParamater('GET_BRANCH', `?${params.toString()}`);
            setPagination(response.data.paginationData);
            const CurrencyData = response.data?.result;
            setCompanies([{ value: null, companyName: 'None' }, ...CompanyRes.data.result]);
            setRowData(CurrencyData);
        } catch (error) {
            console.error("Error fetching Currency data:", error);
        }
    };
    const handleSubmit = async () => {

        if (!formData?.BranchCode) {
            if (!formData?.BranchCode) { toast.warning("Enter Branch Code") }
            return;
        }
        if (!formData.formData?.Company.value.companyId) {
            if (!formData.formData?.Company.value.companyId) { toast.warning("Select Company") }
            return;
        }
        if (!formData.BranchName) {
            if (!formData.BranchName) { toast.warning("Enter Branch Name") }
            return;
        }
        try {
            const apiService = new ApiService()
            let data = {
                branchCode: formData?.BranchCode,
                companyId: formData?.Company.value.companyId,
                isActive: true,
                branchName: formData?.BranchName,
                createdBy: formData?.InventoryAccounts?.label,
            }
            const response = await apiService.post('CREATE_BRANCH', data);

            if (response?.data?.statusCode === 201) {
                toast.success(response?.data?.message)
                fetchBranchData();
                setFormData({
                    BranchCode: "",
                    BranchName: "",
                    Company: []
                });
            } else if (response?.data?.statusCode === 208) {
                toast?.warning(response?.data?.message)
                fetchBranchData();
            }
        } catch (error) {
            toast.error("Please try Again!")
        }
    }
    const updateFormData = async () => {
        try {
            const apiService = new ApiService();
            if (!formData?.BranchCode) {
                if (!formData?.BranchCode) { toast.warning("Enter Branch Code") }
                return;
            }
            if (!formData.formData?.Company.value.companyId) {
                if (!formData.formData?.Company.value.companyId) { toast.warning("Select Company") }
                return;
            }
            if (!formData.BranchName) {
                if (!formData.BranchName) { toast.warning("Enter Branch Name") }
                return;
            }
            let data = {
                record_Id: formData.recordId,
                branchCode: formData?.BranchCode,
                companyId: formData?.Company.value.companyId,
                isActive: true,
                branchName: formData?.BranchName,
                createdBy: formData?.InventoryAccounts?.label,
            }
            const res = await apiService.put(`UPDATE_BRANCH`, data);
            if (res?.data?.statusCode === 201) {
                toast.success(res?.data?.message)
                fetchBranchData();
                window.location.reload()
                window.history.replaceState({}, '')
                setFormData({
                    BranchCode: "",
                    BranchName: "",
                    Company: []
                });
            } else if (res?.data?.statusCode === 208) {
                toast?.warning(res?.data?.message)
                fetchBranchData();
            }
        } catch (error) {
            console.error('Error updating form data:', error);
        }
    };
    const handleClearFilters = () => {
        setFormData({
            BranchCode: "",
            BranchName: "",
            Company: []
        })
        setSelectedRow(null)
        fetchBranchData()
    };
    return (
        <div className='px-4 pt-3'>
            <div className='py-lg-3'>
                <div className='gridBg p-3' style={{ borderRadius: "16px 16px 16px 16px" }}>
                    <div className='d-flex justify-contant-between mb-4'>
                        <h5 className='col mainInvHead'>Branch Master</h5>
                        <div className='d-flex justify-content-end gap-1'>
                            <div
                                onClick={handleEdit}
                                className={`mainbtnSecondary flex-end gap-2 ${!selectedRow ? 'disabled' : ''}`}
                                style={{ cursor: selectedRow ? 'pointer' : 'not-allowed' }}
                            >
                                <GrEdit color='#fff' className='center mt-1 mx-2' />
                                <div className='center'>Edit</div>
                            </div>
                            <div className=''>
                                {selectedRow ? (
                                    <>
                                        {canEditMaster && (
                                            <button className='mainbtn ' onClick={updateFormData}>
                                                <FaSave className='center mt-1 mx-2' /> <div>Update</div></button>
                                        )}
                                    </>
                                ) : (
                                    <>
                                        {canEditMaster === true ?
                                            <button className='mainbtn ' onClick={handleSubmit}>
                                                <FaSave className='center mt-1 mx-2' /> <div>Save</div></button> :
                                            <button className='mainbtn disabled' style={{ cursor: "not-allowed" }}>
                                                <FaSave className='center mt-1 mx-2' /> <div>Save</div>
                                            </button>
                                        }
                                    </>
                                )}
                            </div>
                            <div className=''>
                                <button className='mainbtnRed' onClick={handleClearFilters}><RiRefreshLine className='center mt-1 mx-2' /><div>Reset</div></button>
                            </div>
                        </div>
                    </div>
                    <div className="form-group row">
                        <div className="col-lg-4 d-flex justify-content-between">
                            <label htmlFor="validationCustom01" className="form-label  pt-2 start">Branch Code</label>
                            <input
                                type="text"
                                className="form-Input w-70"
                                id="validationCustom01"
                                disabled={canCreateMaster === true ? false : true}
                                name="BranchCode"
                                value={formData.BranchCode}
                                onChange={handleInputChange}
                                required
                            />
                        </div>
                        <div className="col-lg-4 d-flex justify-content-between">
                            <label htmlFor="validationCustom02" className="form-label  pt-2 start">Select Company</label>
                            <Select
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9
                                })}
                                isDisabled={canCreateMaster === true ? false : true}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                        color: state.isFocused ? '#000 ' : '#000',
                                        ':hover': {
                                            backgroundColor: '#F5F5F5',
                                            color: '#000 ',
                                        },
                                    }),
                                }}
                                className="w-70 p-0"
                                value={formData?.Company}
                                onChange={(selectedOption) => handleCompanyChange(selectedOption)}
                                options={companies?.map((comp) => ({ value: comp, label: comp?.companyName }))}
                            />
                        </div>
                        <div className="col-lg-4 d-flex justify-content-between">
                            <label htmlFor="validationCustom02" className="form-label  pt-2 start">Branch Name</label>
                            <input
                                type="text"
                                className="form-Input w-70"
                                disabled={canCreateMaster === true ? false : true}
                                id="validationCustom02"
                                name="BranchName"
                                value={formData?.BranchName}
                                onChange={handleInputChange}
                                required
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className='gridBg pt-3'>
                <BranchGrid fetchBranchData={fetchBranchData} rowData={rowData} canEditMaster={canEditMaster}
                    setSelectedRow={setSelectedRow} handleEdit={handleEdit} />
                <Pagination pageSize={pageSize} setPageSize={setPageSize} pagination={pagination} getItems={fetchBranchData} />
            </div>
        </div>
    )
}

export default BranchMaster;
